import { render, staticRenderFns } from "./image-libs.vue?vue&type=template&id=8fc7b4ae&scoped=true"
import script from "./image-libs.vue?vue&type=script&lang=js"
export * from "./image-libs.vue?vue&type=script&lang=js"
import style0 from "./image-libs.vue?vue&type=style&index=0&id=8fc7b4ae&prod&lang=scss&scoped=true"
import style1 from "./image-libs.vue?vue&type=style&index=1&id=8fc7b4ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc7b4ae",
  null
  
)

export default component.exports